module.exports = __webpack_public_path__ + "prod/1.42.2/img/editions_banner.85eafc06.png";